import { namespace } from 'vuex-class';
import { BindingHelpers } from 'vuex-class/lib/bindings';
import { IUpdateDocumentState } from './update-document.types';

export const UpdateDocument: BindingHelpers = namespace('documentManipulator/updateDocument');

export function getDefaultState(): IUpdateDocumentState {
  return {
    updating: false,
    updatedDocument: null,
    originalDocument: null,
    updateFailed: false,
  };
}
